// removed by extract-text-webpack-plugin
module.exports = {"confirmWithCloseButton":"hk-confirmWithCloseButton-confirmWithCloseButton"};